module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-fa2772.woff";


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 911
 ** module chunks = 2
 **/